/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Group_Door_EmptyInputs */



/**
* | output |
* | --- |
* | "The check-in code is for in-person events." |
*
* @param {Tools_Group_Door_EmptyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tools_group_door_empty = /** @type {((inputs?: Tools_Group_Door_EmptyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Group_Door_EmptyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le code de pointage est réservé aux événements en présentiel.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El código de check-in es solo para eventos presenciales.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O código de check-in é apenas para eventos presenciais.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il codice di check-in è solo per gli eventi in presenza.")
	return /** @type {LocalizedString} */ ("The check-in code is for in-person events.")
});